import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import classes from "./OrganizationApproval.scss";
import { withCombinedAccessBlocker } from "lib/PermissionAware";
import FeedList from "AppComponents/FeedList";
import { ChevronIcon } from "SvgComponents";
import { getOrganizationApprovalRequestFeed } from "../../modules/ToolingQueries";
import { getUserApprovalRequestFeed } from "../../modules/ToolingQueries";
import { goToBack } from "modules/NavigationModule";
import moment from "moment";
import {
  onClickNavigate,
  approveOrganization,
  changeOrganizationSearchString,
  deleteApproveSchoolRequest,
  deleteApproveUser,
  approveUser,
} from "Tooling/modules/ToolingModule";
import withLoader from "UIComponents/GqlWithLoader";
import Loading from "UIComponents/Loading";
import SearchBar from "UIComponents/SearchBar";
import DialogueBox from "UIComponents/DialogueBox";
import I18nHOC from "UIComponents/I18nHOC";
import { getGlobalConstantsFromCache } from "modules/CommonGraphqlHelpers";
import OrganizationModal from "../OrganizationManagement/OrganizationModal";

const parentStyle = {
  gridTemplateColumns: "18% 16% 14% 12% 14% 12% 5%",
  gridColumnGap: "16px",
};

const columnList = [
  {
    label: "User Name",
    id: "userNameEmail",
    type: "CUSTOM",
    style: { justifySelf: "start" },
  },
  {
    label: "School Name",
    id: "organizationName",
    type: "TEXTCOLUMN",
    style: { justifySelf: "start" },
  },
  {
    label: "Request",
    id: "requestType",
    type: "TEXTCOLUMN",
    style: { justifyContent: "center", justifySelf: "center" },
  },
  {
    label: "On",
    id: "createdAt",
    type: "TEXTCOLUMN",
    style: { justifySelf: "start" },
  },
  {
    label: "Document",
    id: "url",
    type: "CUSTOM",
    style: {
      justifySelf: "start",
    },
  },
  {
    label: "School website",
    id: "webUrl",
    type: "CUSTOM",
    style: {
      justifyContent: "start",
    },
  },
  {
    label: "Actions",
    id: "action",
    type: "ACTIONS",
  },
];

const steps = [
  {
    id: "name",
    label: "School Name",
    ref: "name",
    name: "name",
    placeholder: "Enter organization name",
    validationCheck: true,
    type: "text",
  },
  {
    id: "type",
    label: "School Type",
    ref: "type",
    name: "type",
    placeholder: "Enter type",
    type: "selectDropDown",
  },

  {
    id: "city",
    label: "School City",
    ref: "city",
    name: "city",
    placeholder: "Enter city",
    type: "text",
  },
  {
    id: "country",
    label: "School Country",
    ref: "country",
    name: "country",
    placeholder: "Enter country",
    type: "text",
  },
  {
    id: "domains",
    label: "School Domains",
    ref: "domains",
    name: "domains",
    placeholder: "Enter Domains",
    type: "selectDropDown",
    multi: true,
    allowAddOption: true,
    error: "Provide the domain",
  },
  {
    id: "ibCode",
    label: "School IB Code",
    ref: "ibCode",
    name: "ibCode",
    placeholder: "Enter IB code",
    type: "text",
  },
  {
    id: "firstName",
    label: "User First Name",
    ref: "firstName",
    name: "firstName",
    placeholder: "Enter first name",
    validationCheck: true,
    disabled: true,
    type: "text",
  },
  {
    id: "lastName",
    label: "User Last Name",
    ref: "lastName",
    name: "lastName",
    placeholder: "Enter last name",
    validationCheck: true,
    disabled: true,
    type: "text",
  },
  {
    id: "email",
    label: "User Email",
    ref: "email",
    name: "email",
    placeholder: "Enter email",
    validationCheck: true,
    disabled: true,
    type: "text",
  },
  {
    id: "designation",
    label: "User Role",
    ref: "designation",
    name: "designation",
    placeholder: "Enter role",
    disabled: true,
    type: "selectDropDown",
  },
];

const domainOptions = [];

class OrganizationManagement extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDetailsModal: false,
      orgData: null,
      dialogueBoxScreen: null,
    };
  }

  getFeedData = () => {
    const { organizations } = this.props;
    const filteredList = organizations;

    const feedData = _.map(filteredList, (organization, index) => {
      const id = organization.id;
      return {
        ...organization,
        id: `${id}:${organization["__typename"]}`,
        userNameEmail: {
          userName: `${organization.firstName} ${organization.lastName}`,
          email: organization.email,
        },
        requestType:
          organization.requestType == "ORG" ? "Add School" : "Approve User",
        createdAt: moment(organization.createdAt).format("Do MMM YY"),
        domains: (organization.domains || []).join(", "),
        action: [
          {
            label: "Activate",
            clickAction: () =>
              this.setState({
                dialogueBoxScreen: "approveRequest",
                orgData: {
                  ...organization,
                  designation: _.get(organization, "designation.id", ""),
                },
              }),
          },
          {
            label: "Delete",
            clickAction: () =>
              this.setState({
                dialogueBoxScreen: "rejectRequest",
                orgData: {
                  ...organization,
                  designation: _.get(organization, "designation.id", ""),
                },
              }),
          },
        ],
      };
    });
    return feedData;
  };

  onClose = () => {
    this.setState({ dialogueBoxScreen: null });
  };

  approveRequest = async data => {
    if (data.requestType == "USER") {
      this.props.approveUser(data);
    } else {
      this.props.approveOrganization(data);
    }
  };

  deleteApproveSchoolRequest = data => {
    if (data.requestType == "USER") {
      this.props.deleteApproveUser(data);
    } else {
      this.props.deleteApproveSchoolRequest(data);
    }
  };

  onUpdateInputField = ({ id, data }) => {
    this.setState(prevState => {
      return { orgData: { ...prevState.orgData, [id]: data } };
    });
  };

  getOptions = key => {
    const { designations } = this.props;
    switch (key) {
      case "type":
        return [
          { label: "Candidate School", value: "candidate" },
          { label: "Authorised School ", value: "authorised" },
        ];
      case "designation":
        return _.map(designations, ({ id, title, description }) => {
          return { label: title, value: id, subText: description };
        });

      case "domains":
        return domainOptions;
      default:
        return [];
    }
  };

  getDialogueBox = () => {
    const { dialogueBoxScreen, orgData } = this.state;

    if (dialogueBoxScreen) {
      switch (dialogueBoxScreen) {
        case "rejectRequest":
          return (
            <DialogueBox
              modalTitle="Reject the request"
              onClickButton2={() => this.deleteApproveSchoolRequest(orgData)}
              modalBody="Are you sure you want to reject this request?"
              toggleDialogueBoxDisplay={this.onClose}
              button1="Cancel"
              button2="Reject"
            />
          );
        case "approveRequest":
          return (
            <DialogueBox
              modalTitle="Activate the request"
              onClickButton2={() => this.approveRequest(orgData)}
              modalBody="Are you sure you want to activate this request?"
              toggleDialogueBoxDisplay={this.onClose}
              button1="Cancel"
              button2="Activate"
            />
          );
        case "editRequest":
          return (
            <OrganizationModal
              title={"Add School and User"}
              data={orgData}
              getOptions={this.getOptions}
              steps={steps}
              onClose={this.onClose}
              onSaveClick={this.approveOrganization}
              doneButtonText={"Approve"}
            />
          );
        default:
          return null;
      }
    } else {
      return null;
    }
  };

  onItemClick = id => {
    const school = _.find(this.props.organizations, { id });
    if (school) {
      this.setState({
        orgData: { ...school, designation: school.designation.id },
        dialogueBoxScreen: "editRequest",
      });
    }
  };

  getCustomComponent = ({ column, columnData, id }) => {
    let doesUrlHaveScheme, url;

    switch (column.id) {
      case "url":
        doesUrlHaveScheme =
          columnData &&
          (columnData.includes("https://") ||
            columnData.includes("http://") ||
            columnData.includes("://"));
        url = columnData;
        if (columnData && !doesUrlHaveScheme) {
          url = `//${columnData}`;
        }
        return (
          <div>
            <a
              className={classes.linkColumn}
              href={url}
              rel="noopener noreferrer"
              target="_blank"
            >
              {columnData}
            </a>
          </div>
        );
      case "webUrl":
        doesUrlHaveScheme =
          columnData &&
          (columnData.includes("https://") ||
            columnData.includes("http://") ||
            columnData.includes("://"));
        url = columnData;
        if (columnData && !doesUrlHaveScheme) {
          url = `//${columnData}`;
        }
        return (
          <div className={classes.linkColumn}>
            <a
              className={classes.linkColumn}
              href={url}
              rel="noopener noreferrer"
              target="_blank"
            >
              {columnData}
            </a>
          </div>
        );
      case "userNameEmail":
        return (
          <div className={classes.userNameEmail}>
            <div>{columnData.userName}</div>
            <div className={classes.email}>{columnData.email}</div>
          </div>
        );
      default:
        return null;
    }
  };

  onBackClicked = () => {
    const { goToBack } = this.props;
    goToBack();
  };

  changeSearchTerm = value => {
    this.props.changeOrganizationSearchString({ organizationApproval: value });
  };

  render() {
    const { organizations, searchText, loading } = this.props;
    return (
      <div
        ref={ref => (this.scrollContainer = ref)}
        className={classes.container}
      >
        <div className={classes.headerContainer}>
          <div
            style={{ display: "flex", cursor: "pointer", alignItems: "center" }}
            onClick={this.onBackClicked}
          >
            <div className={classes.backContainer}>
              <ChevronIcon />
            </div>
            <div className={classes.header}>{"Activate User"}</div>
          </div>
        </div>
        <div className={classes.searchContainer}>
          <SearchBar
            placeholder={"Search by school name or user name"}
            searchTerm={searchText}
            changeSearchTerm={this.changeSearchTerm}
            shouldAnimate={false}
            wrapperType={"box"}
          />
        </div>

        <FeedList
          parentStyle={parentStyle}
          columnList={columnList}
          getCustomComponent={this.getCustomComponent}
          feedData={this.getFeedData()}
          fetchMoreFeed={this.fetchMoreFeed}
          onItemClick={this.onItemClick}
          // isItemClickEnable
        />

        {this.getDialogueBox()}
        {loading ? (
          <div className={classes.loadingContainerFull}>
            <Loading />
          </div>
        ) : null}
      </div>
    );
  }
}

const mapActionCreators = {
  approveOrganization,
  onClickNavigate,
  deleteApproveSchoolRequest,
  changeOrganizationSearchString,
  deleteApproveUser,
  approveUser,
  goToBack,
};

const mapStateToProps = (state, ownProps) => {
  const organizationId = state.login.userInfo.org_id;
  const loading = state.tooling.isLoading.orgnizationManagement;
  const globalConstants = getGlobalConstantsFromCache();
  const designations = _.get(globalConstants, "designations", []);
  return {
    isLoading: true,
    isData: false,
    designations,
    accessPermissions: "ToolPortal:ManageOrganization",
    showErrorComp: false,
    searchText: state.tooling.searchString.organizationApproval,
    organizationId,
    loading,
    // organizations: [
    //   {
    //     id: "192",
    //     name: "Toddle International School",
    //     domains: [{ title: "toddleapp.com" }, { title: "lifeofpie.com" }],
    //     city: "Hogwarts",
    //     country: "Winterfell",
    //     ibCode: "51037"
    //   }
    // ]
  };
};

export const getCombineList = ({ users, organizations }) => {
  let combinedList = [];
  _.forEach(users, user => {
    combinedList.push({
      ...user,
      organizationName: user.organizationPreset.name,
      requestType: "USER",
    });
  });
  _.forEach(organizations, organization => {
    combinedList.push({
      ...organization,
      organizationName: organization.name,
      requestType: "ORG",
    });
  });
  combinedList = _.sortBy(combinedList, list => list.createdAt);

  _.reverse(combinedList);
  return combinedList;
};

// export default Organization;
export default compose(
  I18nHOC({ resolve: ["announcement", "common"] }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getOrganizationApprovalRequestFeed, {
    name: "getAllOrganization",
    options: ({ searchText }) => ({
      fetchPolicy: "cache-and-network",
      variables: { searchText },
    }),
    props({ getAllOrganization, ownProps: { searchText, organizationId } }) {
      const organizations = _.get(
        getAllOrganization,
        "organizationManagement.organizationApprovalRequestFeed",
        []
      );
      return {
        organizations,
        isData: getAllOrganization.organizationManagement,
        isLoading:
          getAllOrganization["networkStatus"] == 1 ||
          getAllOrganization["networkStatus"] == 2,
      };
    },
  }),
  graphql(getUserApprovalRequestFeed, {
    name: "getAllOrganization",
    options: ({ searchText }) => ({
      fetchPolicy: "cache-and-network",
      variables: { searchText },
    }),
    props({
      getAllOrganization,
      ownProps: { isData, isLoading, organizations },
    }) {
      const users = _.get(
        getAllOrganization,
        "organizationManagement.userApprovalRequestFeed",
        []
      );

      const userOrgList = getCombineList({ users, organizations });
      return {
        organizations: userOrgList,
        isData: getAllOrganization.organizationManagement && isData,
        isLoading:
          getAllOrganization["networkStatus"] == 1 ||
          getAllOrganization["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  withLoader,
  withCombinedAccessBlocker
)(OrganizationManagement);
